



























import { Component, Prop, Vue } from "vue-property-decorator";
import { NotificationType } from "@/models/NotificationI";
import { EMIT_NOTIFICATION } from "@/store/mutations-types";

@Component
/**
 * Displays the URI of a given CPT
 */
export default class UriPreview extends Vue {
  /**
   * The identifier/name of the custom post type
   */
  @Prop({ required: true, type: String }) readonly type!: string;

  /**
   * The id of the current contribution
   */
  @Prop({ required: true, type: String }) readonly id!: string;

  /**
   * build the cpt uri for returning users
   */
  get contibutionUri(): string {
    // make sure id can only contain hex chars
    const hexPattern = new RegExp("^[0-9A-Za-z]+$");
    if (!hexPattern.test(this.id)) {
      return "invalid uuid detected!";
    }

    // ensure type can only be nubmers, characters and dashses
    const typePattern = new RegExp("^[0-9a-zA-Z-]+$");
    if (!typePattern.test(this.type)) {
      return "invalid cpt type detected!";
    }
    return window.location.origin + "/" + this.type + "/" + this.id;
  }

  /**
   * copy the cpt uri to the client clipboard
   */
  private copyCptUri(): void {
    // https://www.30secondsofcode.org/blog/s/copy-text-to-clipboard-with-javascript
    const el = document.createElement("textarea");
    el.value = this.contibutionUri;
    el.setAttribute("readonly", "");
    el.style.position = "absolute";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);

    this.$store.commit(EMIT_NOTIFICATION, {
      type: NotificationType.SUCCESS,
      title: this.$t("views.proposedCPT.copiedTitle"),
      text: this.$t("views.proposedCPT.copied"),
    });
  }
}
